import { useEffect, useRef } from 'react';
import QRCode from 'qrcode';
import type { PromotionAssetViewModel, TranslationKey } from '@dukanti/shared';
import { useTranslation } from '@dukanti/shared';

export function PromotionPosterPreview(props: {
  readonly asset: PromotionAssetViewModel | null;
}): React.JSX.Element {
  const { t } = useTranslation();
  const canvasRef = useRef<HTMLCanvasElement | null>(null);

  useEffect(() => {
    if (!props.asset || !canvasRef.current) return;
    void QRCode.toCanvas(canvasRef.current, props.asset.publicUrl, { margin: 1, width: 180 });
  }, [props.asset]);

  return (
    <section className="border-border bg-card shadow-admin-card rounded-lg border p-4">
      <h2 className="font-display text-foreground text-xl">
        {t('admin.promotionKit.preview.posterTitle' as TranslationKey)}
      </h2>
      <div
        data-testid="promotion-kit-print-root"
        className="bg-paper text-sand-800 border-sand-200 dark:bg-sand-800 dark:text-sand-50 dark:border-sand-700 mx-auto mt-4 flex aspect-[3/4] max-w-sm flex-col items-center justify-between rounded-xl border p-6 text-center"
      >
        <div>
          <p className="text-zaatar-deep dark:text-zaatar-soft text-sm font-semibold">
            {props.asset?.storeName ?? 'Dukanti'}
          </p>
          <h3 className="text-sand-900 dark:text-sand-50 mt-3 text-2xl font-bold">
            {props.asset?.targetTitle ??
              t('admin.promotionKit.empty.noPublicTargets' as TranslationKey)}
          </h3>
        </div>
        <canvas ref={canvasRef} className="bg-paper dark:bg-sand-50 size-44 rounded-lg p-2" />
        <p className="text-sand-600 dark:text-sand-200 text-sm font-semibold">
          {props.asset ? t(props.asset.ctaKey) : t('promotionKit.poster.cta' as TranslationKey)}
        </p>
        <p className="text-saffron dark:text-saffron-soft text-sm font-bold">Dukanti</p>
      </div>
    </section>
  );
}
